'use strict';

(() => {
  const template = document.createElement('template');

  template.innerHTML = /* html */ `
    <style>
      .element-center { display: flex; -webkit-box-pack: center !important; -ms-flex-pack: center !important; justify-content: center !important; width: 100%; }
      .text-center { text-align: center; }
      .default-field-container { background-color: #f5f5f5; padding: 1.2rem; border: 1px solid #c7c7c7; border-radius: 4px; position: relative; }
    </style>

    <section>
      <div class="default-field-container">
        <slot></slot>
      </div>
    </section>
    `;

  class DefaultField extends HTMLElement {
    #root = null;

    constructor() {
      super();
      this.#root = this.attachShadow({ mode: 'open' });
      this.#root.appendChild(template.content.cloneNode(true));
      this.section = this.#root.querySelector('section');
      this.container = this.#root.querySelector('.default-field-container');
    }

    static get observedAttributes() {
      return ['marin-bottom', 'marin-top', 'section-center', 'content-center', 'text-center', 'max-width'];
    }

    attributeChangedCallback(name, oldValue, newValue) {
      if (name === 'marin-bottom') {
        this.container.style.marginBottom = newValue;
      }
      if (name === 'marin-top') {
        this.container.style.marginTop = newValue;
      }
      if (name === 'section-center') {
        this.section.classList.add('element-center');
      }
      if (name === 'content-center') {
        this.container.classList.add('element-center');
      }
      if (name === 'text-center') {
        this.container.classList.add('text-center');
      }
      if (name === 'max-width') {
        this.container.style.maxWidth = newValue;
      }
    }
  }

  customElements.define('default-field', DefaultField);
})();
